const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// const phoneRe = /^[+\d]?(?:[\d\s\-().]){6,20}$/; // allows +, digits, spaces, dashes, parens (6-20 chars)
const phoneRe = /^\d{10}$/;

const isValidMobileNumber = (phone) => {
  return phoneRe.test(phone);
}

const isValidEmail = (email) => {
  return emailRe.test(email);
}

export { isValidMobileNumber, isValidEmail };